import { api } from './api';

/**
 * Save a crisis simulation run (mineral, timeframe, results, disrupted suppliers, alternatives).
 * Payload must match the Crisis Simulator page data points.
 */
export const saveCrisisSimulation = async (payload) => {
  const response = await api.post('/api/crisis-simulator', payload);
  if (!response.data?.success) throw new Error(response.data?.message || 'Save failed');
  return response.data;
};

/**
 * List latest crisis simulator runs.
 */
export const listCrisisSimulations = async (limit = 100) => {
  const response = await api.get('/api/crisis-simulator', { params: { limit } });
  if (!response.data?.success) throw new Error(response.data?.message || 'List failed');
  return response.data;
};

/**
 * Get a single crisis simulation by id.
 */
export const getCrisisSimulation = async (id) => {
  const response = await api.get(`/api/crisis-simulator/${id}`);
  if (!response.data?.success) throw new Error(response.data?.message || 'Not found');
  return response.data;
};

/**
 * Generate Claude insights from a stored simulation (by id).
 */
export const getCrisisSimulationAiInsights = async (simulationId) => {
  const response = await api.post(`/api/crisis-simulator/${simulationId}/claude-insights`);
  if (!response.data?.success) throw new Error(response.data?.message || 'AI insights failed');
  return response.data;
};

/**
 * Generate Claude insights from inline payload (no save).
 * Payload: same shape as save (mineral_key, mineral_name, selected_timeframe_days, results, disrupted_suppliers, alternatives_ranked).
 */
export const getCrisisSimulationAiInsightsFromPayload = async (payload) => {
  const response = await api.post('/api/crisis-simulator/claude-insights', payload);
  if (!response.data?.success) throw new Error(response.data?.message || 'AI insights failed');
  return response.data;
};
